export const matterLedgerTabId = (tab) =>
  `${tab.type}__${tab.currencyCode ?? ""}`;

export const getMatterLedgerReportName = (tab) => {
  if (tab?.type === "Client" && tab?.currencyCode) {
    return "MatterLedgerClient.trdp";
  }
  return "MatterLedger.trdp";
};

export const getMatterLedgerReportParams = (tab) => {
  if (!tab?.type || tab.type === "ALL" || tab.type === "Undertakings") {
    return {};
  }
  const params = { LedgerPostingType: tab.type };
  if (tab.type === "Client" && tab.currencyCode) {
    params.CurrencyCode = tab.currencyCode;
  }
  return params;
};

export const buildMatterLedgerTabItems = (
  multiCurrencyEnabled,
  clientPostingCurrencies = [],
) => {
  const items = [
    { label: "All", type: "ALL", currencyCode: null },
    { label: "Bills", type: "Sales", currencyCode: null },
    { label: "Disbursements", type: "Purchase", currencyCode: null },
    { label: "Client", type: "Client", currencyCode: null },
  ];
  if (multiCurrencyEnabled) {
    clientPostingCurrencies.forEach((code) => {
      items.push({
        label: `Client ${code}`,
        type: "Client",
        currencyCode: code,
      });
    });
  }
  items.push({
    label: "Undertakings",
    type: "Undertakings",
    currencyCode: null,
  });
  return items;
};
